import { combineReducers } from 'redux'
import * as actions from '../actions'

const isLoggedIn = (state = false, action) => {
  switch (action.type) {
    case actions.LOG_IN:
      return true
    case actions.LOG_OUT:
      return false
    case actions.HANDLE_TOKEN:
      return !!action.token
    default:
      return state
  }
}

// TODO fix
// eslint-disable-next-line complexity
const status = (
  state = {
    isLoggedIn: false,
    authenticating: false,
    method: 'local',
    modalActive: false,
    isLogIn: false,
    error: false,
    incorrectCredentials: false,
    continueSignUp: false
  },
  action
) => {
  switch (action.type) {
    case actions.AUTHENTICATING:
      return {
        ...state,
        authenticating: true,
        error: false,
        incorrectCredentials: false,
        method: action.method
      }
    case actions.ERROR_AUTHENTICATING:
      return {
        ...state,
        authenticating: false,
        error: true
      }
    case actions.INCORRECT_CREDENTIALS:
      return {
        ...state,
        authenticating: false,
        incorrectCredentials: true
      }
    case actions.LOG_IN:
      return {
        ...state,
        isLoggedIn: true,
        authenticating: false,
        error: false,
        incorrectCredentials: false
      }
    case actions.LOG_OUT:
      return {
        ...state,
        isLoggedIn: false
      }
    case actions.HANDLE_AUTH_MODAL:
      return {
        ...state,
        modalActive: action.value,
        error: false,
        authenticating: false,
        incorrectCredentials: false,
        continueSignUp: false
      }
    case actions.IS_LOG_IN:
      return {
        ...state,
        isLogIn: action.value
      }

    case actions.CONTINUE_SIGN_UP:
      return {
        ...state,
        continueSignUp: true
      }
    case actions.SIGN_UP_BACK:
      return {
        ...state,
        continueSignUp: false
      }

    default:
      return state
  }
}

const token = (state = null, action) => {
  switch (action.type) {
    case actions.HANDLE_TOKEN:
      return action.token
    case actions.LOG_OUT:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isLoggedIn,
  status,
  token
})
